import { MeasurementsStyleConfig } from '../MeasurementsManager';

export const lineComponentIds = {
	line: 'Line-',
	decorMax: 'Line-decor-max-',
	decorMin: 'Line-decor-min-',
	extended: 'Line-extended-',
	extendedDecorMax: 'Line-extended-decor-max-',
	extendedDecorMin: 'Line-extended-decor-min-',
};

export const textComponentId = 'Text-';
export const measurementId = 'measurement';
export const defaultConfig: MeasurementsStyleConfig = {
	line: {
		isDashed: false,
		color: { r: 0.25, g: 0.25, b: 0.25 },
	},
	exLine: {
		isDashed: true,
		color: { r: 0.35, g: 0.35, b: 0.35 },
		dashSize: 6,
		gapSize: 4,
		dashNb: 28,
	},
	text: {
		backgroundColor: '#ffffff',
		fontSize: 16,
		color: '#222',
		fontFamily: 'notoIKEAlatin',
	},
	height: 0,
	linesOffset: 3,
	decorLength: 0.4,
	textOffset: 6,
	isHidden: true,
};
